export var I18nLocales;
(function (I18nLocales) {
    I18nLocales["FR"] = "fr";
    I18nLocales["EN"] = "en";
    I18nLocales["ES"] = "es";
    I18nLocales["DE"] = "de";
})(I18nLocales || (I18nLocales = {}));
export var Locales;
(function (Locales) {
    Locales["FR"] = "FR";
    Locales["EN"] = "EN";
    Locales["ES"] = "ES";
    Locales["DE"] = "DE";
})(Locales || (Locales = {}));
export var CadLocales;
(function (CadLocales) {
    CadLocales["FR"] = "FR";
    CadLocales["EN"] = "EN";
})(CadLocales || (CadLocales = {}));
export var UsaLocales;
(function (UsaLocales) {
    UsaLocales["EN"] = "EN";
    UsaLocales["ES"] = "ES";
})(UsaLocales || (UsaLocales = {}));
export var GbLocales;
(function (GbLocales) {
    GbLocales["EN"] = "EN";
})(GbLocales || (GbLocales = {}));
export var AuLocales;
(function (AuLocales) {
    AuLocales["EN"] = "EN";
})(AuLocales || (AuLocales = {}));
export var NzLocales;
(function (NzLocales) {
    NzLocales["EN"] = "EN";
})(NzLocales || (NzLocales = {}));
export var IeLocales;
(function (IeLocales) {
    IeLocales["EN"] = "EN";
})(IeLocales || (IeLocales = {}));
export var DeLocales;
(function (DeLocales) {
    DeLocales["DE"] = "DE";
})(DeLocales || (DeLocales = {}));
export var CadIsoLocale;
(function (CadIsoLocale) {
    CadIsoLocale["FR"] = "fr-CA";
    CadIsoLocale["EN"] = "en-CA";
})(CadIsoLocale || (CadIsoLocale = {}));
export var UsaIsoLocale;
(function (UsaIsoLocale) {
    UsaIsoLocale["EN"] = "en-US";
    UsaIsoLocale["ES"] = "es-US";
})(UsaIsoLocale || (UsaIsoLocale = {}));
export var GbIsoLocale;
(function (GbIsoLocale) {
    GbIsoLocale["EN"] = "en-GB";
})(GbIsoLocale || (GbIsoLocale = {}));
export var AuIsoLocale;
(function (AuIsoLocale) {
    AuIsoLocale["EN"] = "en-AU";
})(AuIsoLocale || (AuIsoLocale = {}));
export var NzIsoLocale;
(function (NzIsoLocale) {
    NzIsoLocale["EN"] = "en-NZ";
})(NzIsoLocale || (NzIsoLocale = {}));
export var IeIsoLocale;
(function (IeIsoLocale) {
    IeIsoLocale["EN"] = "en-IE";
})(IeIsoLocale || (IeIsoLocale = {}));
export var DeIsoLocale;
(function (DeIsoLocale) {
    DeIsoLocale["DE"] = "de-DE";
    DeIsoLocale["EN"] = "en-DE";
})(DeIsoLocale || (DeIsoLocale = {}));
export const allowedNextLocales = Object.values(I18nLocales);
export const allowedNextIsoLocales = [
    ...Object.values(GbIsoLocale),
    ...Object.values(UsaIsoLocale),
    ...Object.values(CadIsoLocale),
    ...Object.values(AuIsoLocale),
    ...Object.values(IeIsoLocale),
    ...Object.values(DeIsoLocale),
];
export const allowedNextLocalesAndIsoLocales = [...allowedNextLocales, ...allowedNextIsoLocales];
